import localData, { checkPermissions } from '@/utils/saveDataToLocal';

export default {
  methods: {
    checkPermission(condition) {
      return localData.checkPermission(condition);
    },
    checkPermissions,
  },
};
